
// src/web/components/guide-message.jsx

import React from 'react'
import theme from './themes/guide-message.css'

class GuideMessage extends React.PureComponent {
  render() {
    const {
      showMessage,
      message,
      style,
      diaryGuidance
    } = this.props

    if (!showMessage)
      return null

    return (
      <div className={diaryGuidance ? theme.diaryGuidance : theme.message} style={style}>
        {message}
      </div>
    )
  }
}

export default GuideMessage



// WEBPACK FOOTER //
// ./src/web/components/guide-message.jsx